import ScalarListboxCheckbox_vue_vue_type_script_setup_true_lang_default from "./ScalarListboxCheckbox.vue.script.js";
//#region src/components/ScalarListbox/ScalarListboxCheckbox.vue
var ScalarListboxCheckbox_default = ScalarListboxCheckbox_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarListboxCheckbox_default as default };

//# sourceMappingURL=ScalarListboxCheckbox.vue.js.map